import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PublicLayout from '@/components/PublicLayout';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PrivacyPolicyPage = () => {
  const [loading, setLoading] = useState(true);
  const [pageContent, setPageContent] = useState({ 
    title: 'Privacy Policy', 
    content: 'Loading official policy...' 
  });
  const [pageEnabled, setPageEnabled] = useState(true);

  useEffect(() => {
    fetchPageContent();
    window.scrollTo(0, 0);
  }, []);

  const fetchPageContent = async () => {
    try {
      const [pageRes, settingsRes] = await Promise.all([
        axios.get(`${API}/custom-pages/privacy-policy`),
        axios.get(`${API}/site-settings`)
      ]);
      
      setPageContent(pageRes.data);
      const isEnabled = settingsRes.data.pages_enabled?.privacy_policy !== false;
      setPageEnabled(isEnabled);
      
      if (!isEnabled) {
        toast.error('This page is currently unavailable');
      }
    } catch (error) {
      console.error('Failed to fetch privacy policy');
      toast.error('Failed to load content. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <PublicLayout>
        <div className="flex items-center justify-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1A4D2E]"></div>
        </div>
      </PublicLayout>
    );
  }

  if (!pageEnabled) {
    return (
      <PublicLayout>
        <div className="flex items-center justify-center py-20 text-center">
          <div>
            <h2 className="text-2xl font-bold text-stone-700 mb-2">Policy Unavailable</h2>
            <p className="text-stone-600">This legal notice is currently being updated.</p>
          </div>
        </div>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 
          className="text-4xl md:text-5xl font-bold text-[#1A4D2E] mb-8" 
          style={{fontFamily: '"Playfair Display", serif'}}
        >
          {pageContent.title}
        </h1>
        
        <Card className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-stone-100">
          <div className="prose prose-lg max-w-none">
            {/* Simple text rendering to bypass build errors */}
            <p className="text-lg text-stone-700 leading-relaxed whitespace-pre-line">
              {pageContent.content}
            </p>
          </div>
          
          <div className="mt-12 pt-8 border-t border-stone-100 text-stone-500 text-sm">
            <p>Last Updated: {new Date(pageContent.updated_at || Date.now()).toLocaleDateString()}</p>
            <p className="mt-2">For privacy inquiries, contact support@albriks.com</p>
          </div>
        </Card>
      </div>
    </PublicLayout>
  );
};

export default PrivacyPolicyPage;
